(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[598],{

/***/ 4588:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/equal-opportunities",
      function () {
        return __webpack_require__(9706);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8077);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4115);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8017);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);





var EqualOpportunities = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_3__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "101Digital | Equal Opportunities"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                as: "h1",
                textStyle: "h1",
                textAlign: [
                    "center",
                    null,
                    null,
                    null,
                    null,
                    "left"
                ],
                mb: [
                    "34px",
                    null,
                    null,
                    null,
                    null,
                    "136px"
                ],
                mt: [
                    "45px",
                    null,
                    null,
                    null,
                    null,
                    "132px"
                ],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                    children: "Equal Opportunities"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                maxW: "1155px",
                w: "100%",
                mb: [
                    "34px",
                    null,
                    null,
                    null,
                    null,
                    "99px"
                ],
                px: [
                    "28px",
                    null,
                    null,
                    null,
                    null,
                    "16px"
                ],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                    textStyle: "paragraph",
                    color: "primary",
                    fontSize: [
                        "12px",
                        null,
                        null,
                        null,
                        null,
                        "21px"
                    ],
                    fontWeight: 300,
                    children: [
                        "The Company considers all forms of discrimination to be unacceptable in the workplace. The Company is committed to providing equal opportunities throughout employment, including in the remuneration, recruitment, training and promotion of staff.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        }),
                        "The Company is committed to ensuring that no employee receives less favourable treatment or is unlawfully discriminated against on grounds of disability, gender, sex, sexual orientation, marital status, race, colour, religious convictions, age, nationality or ethnic origin.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        }),
                        "The Company is an equal opportunities employer. All appointments and promotions are made on the basis of performance and ability. We are committed to the continued development of the personal and business skills of our employees and you will be treated in a fair and unbiased way and given every encouragement to realise your potential.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        }),
                        "All employees will be made aware of the provisions of this policy and all employees are required to ensure that the policy is carried out properly as in addition to being committed to equal opportunities internally within the workplace, the Company is committed to clients and Candidates being treated equally.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        }),
                        "The Company is committed to its Candidates being assessed in accordance with their merits and qualifications and ability to perform the relevant duties required by a particular vacancy. The Company will not tolerate unlawful discrimination against or towards any Candidates or client or prospective client."
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (EqualOpportunities);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [425,77,774,888,179], function() { return __webpack_exec__(4588); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);